import { Products } from '../components';

const Home = () => (
  <main className="main">
    <Products />
  </main>
);

export default Home;
